<template>
  <div class="md:grid-cols-2 grid grid-flow-row grid-cols-1 gap-4">
    <div v-for="file in documentList" :key="file.docName">
      <a :href="file.link" target="_blank">
        <div
          class="rounded-2xl hover-hover:hover:bg-primary flex items-center p-2 border"
        >
          <span v-html="file.docName" />
          <div class="flex-1" />
          <div class="flex-shrink-0 w-8 h-8 p-1 mx-1 border rounded-full">
            <download-icon :is="iconComponent" class="w-full h-full" />
          </div>
          <span v-text="file.label" />
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import DownloadIcon from "./icons/DownloadIcon.vue";
export default {
  components: { DownloadIcon },
  props: {
    documentList: Array
  }
};
</script>
